export {
  GA4_CUSTOM_DIMENSIONS,
  GA_CONSENT_STORAGE_KEY,
  GA_EXCLUDED_PATH_PREFIXES,
  GA_MEASUREMENT_ID,
  GA_REQUIRE_CONSENT,
} from './constants';
export {
  isAnalyticsConsentGranted,
  readStoredAnalyticsConsent,
  writeStoredAnalyticsConsent,
} from './consent';
export {
  canSendAnalytics,
  clearShelterAnalyticsContext,
  isGaConfigured,
  mergeGaEventParams,
  setShelterAnalyticsContext,
  trackGaEvent,
  trackGaPageView,
  updateGaConsent,
} from './gtag';
export { isGaEnabledForPath, isPathExcludedFromGaPageViews } from './pathPolicy';
export {
  trackAdoptionApplicationClick,
  trackMatchAnimalImpression,
  trackProfileLinkClick,
  trackQuizComplete,
  trackQuizPageView,
  trackQuizPreferencesFromProfile,
  trackQuizStart,
} from './quizAnalytics';
export {
  appendEmailShareUtmParams,
  appendFriendrUtmParams,
  appendSocialShareUtmParams,
} from './utmParams';
export {
  GA4_EVENT_NAMES,
  type Ga4ConsentStatus,
  type Ga4EventName,
  type Ga4EventParams,
  type Ga4Surface,
} from './types';
